import {QUERY} from './QueryTypes'

export const setQuery = query => {
    return {
        type: QUERY,
        load: query
    }
}